import type { ImageOps } from "../types";

// Dynamic import for sharp to handle optional dependency
let sharp: any = null;
try {
  sharp = require("sharp");
} catch (error) {
  // Sharp not available
}

export const nodeImageOps: ImageOps = {
  async svgToPng(svg: string): Promise<string> {
    if (!sharp) {
      console.warn("Sharp not available, falling back to SVG format");
      // Return SVG as data URL instead of PNG
      return `data:image/svg+xml;base64,${Buffer.from(svg).toString("base64")}`;
    }
    const png = await sharp(Buffer.from(svg)).png().toBuffer();
    return `data:image/png;base64,${png.toString("base64")}`;
  },

  isAvailable(): boolean {
    return sharp !== null;
  },
};

// Runtime guard
if (typeof (globalThis as any).EdgeRuntime !== "undefined") {
  throw new Error(
    "DataShows SDK: Node adapter loaded in Edge runtime. Use `datashows-sdk/edge` or ensure your bundler picks the correct entry point."
  );
}
